/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useMaintenanceStyles = makeStyles(theme =>
  createStyles({
    logoContainer: {
      cursor: 'pointer',
    },
    logoImage: {
      width: '163px',
      height: 'auto',
    },
    descriptionText: {
      fontSize: '32px',
      lineHeight: '40px',
      letterSpacing: '-0.22px',
      color: '#FEFFFF',
      paddingLeft: theme.spacing(10),
      paddingRight: theme.spacing(10),
      textAlign: 'center',
    },
    button: {
      padding: `${theme.spacing()}px ${theme.spacing(3)}`,
    },
  }),
);
